import axiosInstance from "../utils/axios";

export const getEventScoreList = async () => {
    try {
        const response = await axiosInstance.get("/api/CompanyEventScore/GetList");

        const resData = response.data;

        //Success case
        if (resData?.statusCode === 200 && resData?.status === "Success") {
            return {
                success: true,
                message: resData.message || "Company event scores retrieved successfully",
                data: resData.data || [],
                totalRecords: resData.totalRecords || (resData.data?.length ?? 0),
            };
        }

        // API returned failure response
        return {
            success: false,
            message: resData?.message || "Failed to fetch company event scores",
            data: [],
            totalRecords: 0,
        };
    } catch (error) {
        console.error("Error fetching company event scores:", error);

        return {
            success: false,
            message: "Something went wrong while fetching event scores",
            error: error.response?.data?.message || error.message,
            data: [],
            totalRecords: 0,
        };
    }
};

export const upsertEventScore = async (payload) => {
    try {
        const response = await axiosInstance.post("/api/CompanyEventScore/Upsert", payload);
        const resData = response.data;

        if (resData?.statusCode === 200 && resData?.status === "Success") {
            return {
                success: true,
                message: resData.message || "Event score saved successfully",
                data: resData.data || null,
            };
        }

        return {
            success: false,
            message: resData?.message || "Failed to save event score",
            data: null,
        };
    } catch (error) {
        console.error("Error upserting event score:", error);
        return {
            success: false,
            message: "Something went wrong while saving event score",
            error: error.response?.data?.message || error.message,
            data: null,
        };
    }
};

export const getMasterFormFields = async () => {
    try {
        const response = await axiosInstance.get(`/api/FormDesk/GetMasterFormFields?ShowReferral=${true}`);

        const resData = response.data;

        //Parse stringified JSON safely
        let parsedData = [];
        try {
            parsedData =
                typeof resData.data === "string"
                    ? JSON.parse(resData.data)
                    : resData.data || [];
        } catch (parseError) {
            console.warn("Error parsing MasterFormFields JSON:", parseError);
            parsedData = [];
        }

        // Success Case
        if (resData?.statusCode === 200 && resData?.status === "Success") {
            return {
                success: true,
                message: resData.message || "Master form fields fetched successfully",
                data: parsedData,
                totalRecords: resData.totalRecords || parsedData.length || 0,
            };
        }

        // API returned a failure response
        return {
            success: false,
            message: resData?.message || "Failed to fetch master form fields",
            data: [],
            totalRecords: 0,
        };
    } catch (error) {
        console.error("Error fetching master form fields:", error);

        return {
            success: false,
            message: "Something went wrong while fetching master form fields",
            error: error.response?.data?.message || error.message,
            data: [],
            totalRecords: 0,
        };
    }
};
